import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(privacyPolicyRoute);

    /** @ngInject */
    function privacyPolicyRoute($stateProvider) {
        $stateProvider.state('privacy_policy', {
            url: '/polityka-prywatnosci',
            template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/privacy-policy/privacy-policy.html'),
            controller: 'PrivacyPolicyController',
            controllerAs: 'PrivacyPolicyCtrl',
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/privacy-policy/privacy-policy.route.ts